import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spdr } from "../Spdr";
import { spdrUrls } from "../../../URL/ApplicationUrls";
import { addSuccessMessage } from "../../../Messages/successMessages";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useAddSpdr = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (spdr: Spdr) => {
      return axios.post<number>(spdrUrls.addSpdr.apiUrl, {
        ...spdr,
      });
    },
    onSuccess: async (response: AxiosResponse) => {
      navigate(spdrUrls.spdrWithId(response.data).uiPath);
      toast.success(addSuccessMessage(response.data, "SPDR"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
